import { observer } from "mobx-react"
import { useTranslation } from "react-i18next"
import { useContainerInjection } from "../../hooks/useContainerInjection"
import { B2BViewModel } from "./B2BViewModel"
import { ReactComponent as RunningIcon } from "../../assets/icons/running.svg"
import { ReactComponent as GroupIcon } from "../../assets/icons/group.svg"
import { ReactComponent as PaperIcon } from "../../assets/icons/paper.svg"
import { Card, Col, Row } from "antd"
import B2BWideImage from "../../assets/images/b2b-img-horizontal.png"
import { FormField } from "../../components/Form/FormField"
import MainForm from "../../components/Form/MainForm"
import { InputType } from "../../components/TextInput/const/InputType.enum"
import MultimediaUploader from "../../components/MultimediaUploader/MultimediaUploader"

const B2BView = () => {
	const { t } = useTranslation("b2b")
	const viewModel = useContainerInjection<B2BViewModel>("B2BViewModel")
	return (
		<MainForm
			initialValues={viewModel.formData[viewModel.selectedLocale]}
			onSubmitForm={() => viewModel.updateB2B()}
		>
			<Row gutter={[24, 0]} className="px-4">
				<Col span={8}>
					<FormField.Select
						name="locale"
						value={viewModel.selectedLocale}
						label={t("locale")}
						onChange={value => viewModel.setSelectedLocale(value)}
						options={[
							{
								label: t("es"),
								value: "es-es"
							},
							{
								label: t("en"),
								value: "en-us"
							},
							{
								label: t("ca"),
								value: "ca-es"
							}
						]}
					/>
				</Col>
			</Row>
			<Row gutter={[24, 0]}>
				<Col span={24} className="flex flex-col items-center">
					<h1 className="mt-0">{t("headerImage")}</h1>
					<MultimediaUploader
						containerStyle={{ height: "350px", width: "420px" }}
						mediaUrl={
							(viewModel.formData[viewModel.selectedLocale]?.headerImage as string & File) ?? undefined
						}
						manualUpload
						onClean={() =>
							viewModel.setSelectedLocaleFormData({
								...viewModel.formData[viewModel.selectedLocale],
								headerImage: null
							})
						}
						onChange={headerImage =>
							viewModel.setSelectedLocaleFormData({
								...viewModel.formData[viewModel.selectedLocale],
								headerImage
							})
						}
						loading={viewModel.loading}
						sizeLimit={{ width: 560, height: 450 }}
					/>
				</Col>
			</Row>
			<Row gutter={[24, 0]} className="mt-3 pl-6" justify="center">
				<h1>{t("cards")}</h1>
			</Row>
			<Row gutter={[24, 0]} className="mb-5 px-6">
				<Col xl={8} md={24} xs={24}>
					<Card className="p-3 pt-1" loading={viewModel.loading}>
						<div className="flex flex-col">
							<RunningIcon className="mb-3" />
							<FormField.Input
								key={"leftCardTitle"}
								name={"leftCardTitle"}
								mandatory
								onChange={(leftCardTitle: string) =>
									viewModel.setSelectedLocaleFormData({
										...viewModel.formData[viewModel.selectedLocale],
										leftCardTitle
									})
								}
							/>
							<FormField.Input
								inputType={InputType.TEXTAREA}
								key={"leftCardText"}
								name={"leftCardText"}
								mandatory
								onChange={(leftCardText: string) =>
									viewModel.setSelectedLocaleFormData({
										...viewModel.formData[viewModel.selectedLocale],
										leftCardText
									})
								}
							/>
						</div>
					</Card>
				</Col>
				<Col xl={8} md={24} xs={24}>
					<Card className="p-3 pt-1" loading={viewModel.loading}>
						<div className="flex flex-col">
							<GroupIcon className="mb-3" />
							<FormField.Input
								key={"middleCardTitle"}
								name={"middleCardTitle"}
								mandatory
								onChange={(middleCardTitle: string) =>
									viewModel.setSelectedLocaleFormData({
										...viewModel.formData[viewModel.selectedLocale],
										middleCardTitle
									})
								}
							/>
							<FormField.Input
								inputType={InputType.TEXTAREA}
								key={"middleCardText"}
								name={"middleCardText"}
								mandatory
								onChange={(middleCardText: string) =>
									viewModel.setSelectedLocaleFormData({
										...viewModel.formData[viewModel.selectedLocale],
										middleCardText
									})
								}
							/>
						</div>
					</Card>
				</Col>
				<Col xl={8} md={24} xs={24}>
					<Card className="p-3 pt-1" loading={viewModel.loading}>
						<div className="flex flex-col">
							<PaperIcon className="mb-3" />
							<FormField.Input
								key={"rightCardTitle"}
								name={"rightCardTitle"}
								mandatory
								onChange={(rightCardTitle: string) =>
									viewModel.setSelectedLocaleFormData({
										...viewModel.formData[viewModel.selectedLocale],
										rightCardTitle
									})
								}
							/>
							<FormField.Input
								inputType={InputType.TEXTAREA}
								key={"rightCardText"}
								name={"rightCardText"}
								mandatory
								onChange={(rightCardText: string) =>
									viewModel.setSelectedLocaleFormData({
										...viewModel.formData[viewModel.selectedLocale],
										rightCardText
									})
								}
							/>
						</div>
					</Card>
				</Col>
			</Row>
			<Row gutter={[24, 0]}>
				<Col span={24} className="flex flex-col items-center">
					<h1 className="mt-0">{t("wideImage")}</h1>
					<MultimediaUploader
						containerStyle={{ height: "30vw", width: "80vw" }}
						mediaUrl={
							(viewModel.formData[viewModel.selectedLocale]?.wideImage as string & File) ?? undefined
						}
						manualUpload
						onClean={() =>
							viewModel.setSelectedLocaleFormData({
								...viewModel.formData[viewModel.selectedLocale],
								wideImage: null
							})
						}
						onChange={wideImage =>
							viewModel.setSelectedLocaleFormData({
								...viewModel.formData[viewModel.selectedLocale],
								wideImage
							})
						}
						sizeLimit={{ width: 1600, height: 560 }}
						loading={viewModel.loading}
					/>
				</Col>
			</Row>
		</MainForm>
	)
}

export default observer(B2BView)
